<template>
	<div class="puzzle">
		<div class="puzzle_item" v-for="(day, index) in puzzles" :key="index">
			<p class="order">
				<span>
					{{ day.date.day }}
				</span>
			</p>
			<div class="content">
				<IconLamp />
				<button class="_btn _btn-remove" v-if="day.homework" @click="$emit('openModalDelete', day.homework.id)">
					<i class="fa fa-trash" aria-hidden="true" />
				</button>

				<button v-if="day.homework" @click="
					$emit('openModalCopy', {
						id: day.homework.id,
						order: day.order,
						slide,
					})
					" class="_btn _btn-copy">
					<i class="fa fa-clone" aria-hidden="true"></i>
				</button>

				<span v-if="day.homework" class="current-date">
					{{ day.homework.created | getCurrentDate }}
				</span>

				<router-link v-if="day.homework" :to="{
					name: `${$route.fullPath.indexOf('group') >= 0 ? 'Group' : 'Profile'
						} Homework Create`,
					params: { id: $route.params.id },
					query: {
						homework: day.homework.id,
						date: day.formattedDate,
						order: day.order,
					},
				}" class="_button">
					{{ 'Edit' | translate }}
				</router-link>
				<router-link v-else-if="!day.homework" :to="{
					name: `${$route.fullPath.indexOf('group') >= 0 ? 'Group' : 'Profile'
						} Homework Create`,
					params: { id: $route.params.id },
					query: {
						date: day.formattedDate,
						order: day.order,
					},
				}" class="_button">
					{{ 'Create' | translate }}
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import IconLamp from '../../../svg/IconLamp'

export default {
	components: {
		IconLamp,
	},
	name: 'PuzzleForTeacher',
	props: ['puzzles', 'openModalDelete', 'openModalCopy', 'slide'],
	filters: {
		getCurrentDate: function (value) {
			const currentDate = new Date(value)

			return `${currentDate.getDate()}.${currentDate.getMonth() +
				1}.${currentDate.getFullYear()}`
		},
	},
}
</script>

<style lang="scss" scoped>
@mixin circle($color: #6a5ea4) {
	content: '';
	width: 39px;
	height: 39px;
	border-radius: 10em;
	position: absolute;
	z-index: 1;
	background-color: $color;
}

.puzzle {
	margin: 5px auto;
	border-radius: 20px;
	overflow: hidden;
	display: grid;
	grid-template-columns: repeat(5, 211px);
	grid-template-rows: repeat(4, 158px);

	@media only screen and (max-width: 1200px) and (min-width: 480px) {
		width: 100%;
		grid-template-columns: repeat(3, 1fr);
		grid-template-rows: repeat(6, 158px);

		>*:last-child {
			grid-column-start: 2;
			grid-column-end: -1;
			background-color: #6d4a98 !important;

			&:after,
			&:before {
				background-color: #6d4a98 !important;
			}

			&:before {
				left: 25% !important;
			}
		}
	}

	@media (max-width: 480px) {
		grid-template-columns: 1fr;
		grid-template-rows: repeat(20, minmax(100px, auto));
		width: 100%;

		&_item {
			&:nth-child(odd) {

				&:before,
				&:after {
					display: none;
				}
			}

			svg {
				display: none;
			}
		}
	}

	&_item {
		color: #fff;
		position: relative;
		padding: 9px;
		display: flex;

		&:nth-child(odd) {
			background-color: #6a5ea4;

			&:before {
				@include circle;
				left: 0;
				top: 50%;
				transform: translate(-50%, -50%);
			}

			&:after {
				@include circle;
				right: 0;
				top: 50%;
				transform: translate(50%, -50%);
			}
		}

		&:nth-child(even) {
			background: #e9407a;

			&:before {
				@include circle(#e9407a);
				top: 0;
				left: 50%;
				transform: translate(-50%, -50%);
			}

			&:after {
				@include circle(#e9407a);
				left: 50%;
				bottom: 0;
				transform: translate(-50%, 50%);
			}
		}

		//&:hover {
		//	._btn-remove {
		//		transform: translateX(0);
		//	}
		//
		//	._btn-copy {
		//		transform: translateX(0);
		//
		//	}
		//}
	}
}

.order {
	position: absolute;
	font-size: 20px;
	padding: 2px;
	left: 4px;
	top: 4px;
	background-color: #e6e9f3;
	height: 40px;
	width: 40px;
	border-radius: 10em;
	box-shadow: 2px 2px 0 #6a5ea4;

	span {
		height: 100%;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #212529 !important;
		border: 1px dashed #e9407a;
		border-radius: 10em;
		font-weight: bold !important;
	}
}

.content {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	padding: 20px;
	gap: 20px;

	svg {
		margin-left: auto;
		margin-right: auto;
		flex-shrink: 0;
	}
}

._button {
	color: #fff;
	text-decoration: none;
	background: #e69c50;
	box-shadow: 0 4px 0 #8f4a68;
	border-radius: 30px;
	min-width: 120px;
	padding: 5px 10px;
	height: 32px;
	display: flex;
	justify-content: center;
	align-items: center;
}

._btn {
	position: absolute;
	background-color: rgba(#fff, 0.3);
	width: 30px;
	height: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	border: 0;
	border-radius: 3px;

	.fa.fa-trash:before,
	.fa-clone:before {
		color: #fff;
		font-size: 18px;
	}

	&:hover {
		background-color: rgba(#fff, 0.4);
	}

	&-copy {
		right: 50px;
		//transform: translateX(100px);
		top: 10px;
		transition: transform 0.25s ease-in-out;
		transition-delay: 0.25s;
	}

	&-remove {
		right: 10px;
		//transform: translateX(100px);
		top: 10px;
		transition: transform 0.15s ease-in-out;
	}
}

.current-date {
	position: absolute;

	right: 12px;
	//transform: translateX(100px);
	top: 45px;

	color: rgba(#fff, 0.5) !important;
}
</style>
